import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Routes from "./Routes";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }


  render() {
    const childProps = {
    };

    return (
      <div className="App container">
        <Navbar  collapseOnSelect>
        <Navbar.Brand>
        <a href="http://www.carabinerweb.com">Made with CarabinerWeb </a>
        </Navbar.Brand>
        </Navbar>
        <Routes childProps={childProps} />
      </div>
    );
  }
}

export default withRouter(App);
